export default "__VITE_ASSET__ALUnVFw4__"